import React from 'react';
import TeamsPage from './TeamsPage';
import AltContainer from 'alt-container';
import TeamActions from 'actions/TeamActions';
import TeamMoveDialogActions from 'actions/TeamMoveDialogActions';
import TeamMoveDialogStore from 'stores/TeamMoveDialogStore';
import DepartmentFormActions from 'actions/DepartmentFormActions';
import DepartmentActions from 'actions/department/DepartmentActions';
import TeamListStore from 'stores/TeamListStore';
import DepartmentStore from 'stores/department/DepartmentStore';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import AdminFormDataStore from 'stores/admin/AdminFormDataStore';
import UserActions from 'actions/UserActions';
import UserStore from 'stores/UserStore';
import {Role} from 'records/User';

export default class TeamsContainer extends React.PureComponent {
  componentDidMount() {
    DepartmentActions.fetchDepartmentProfiles(true).then(profiles =>
      profiles.forEach(({id}) => TeamActions.fetchTeamsForDepartment(id))
    );
    UserActions.fetchAll({
      roles: [Role.MANAGER, Role.ADMIN],
    });
  }
  render() {
    return (
      <AltContainer
        stores={{
          AdminFormDataStore,
          DepartmentFormStore,
          DepartmentStore,
          TeamListStore,
          TeamMoveDialogStore,
          UserStore,
        }}
        actions={{
          DepartmentActions,
          DepartmentFormActions,
          TeamActions,
          TeamMoveDialogActions,
        }}>
        <TeamsPage />
      </AltContainer>
    );
  }
}
